import React, { useState, useEffect } from 'react';
import { RecommendedKeyword } from '../../../types/searchType';
import './SearchKeywords.css';
import iconPopstar from '../../../assets/icons/icon_popstar.svg';
import iconSearch from '../../../assets/icons/icon_search.svg';

interface SearchKeywordsProps {
  onKeywordClick: (keyword: string) => void;
}

const SearchKeywords: React.FC<SearchKeywordsProps> = ({ onKeywordClick }) => {
  const [keywords, setKeywords] = useState<RecommendedKeyword[]>([]);

  useEffect(() => {
    const storedKeywords = localStorage.getItem('recommendedKeywords');
    if (storedKeywords) {
      setKeywords(JSON.parse(storedKeywords));
    }
  }, []);

  return (
    <div className="search-keywords">
      <h2 className="search-keywords-title">You may like</h2>
      {keywords && keywords.length > 0 ? (
        <ul className="keyword-list">
          {keywords.map((keyword) => (
            <li 
              key={keyword.id} 
              className="keyword-item"
              onClick={() => onKeywordClick(keyword.name)}
              style={{ cursor: 'pointer' }}
            >
              <img src={iconPopstar} alt="Popular" className="keyword-icon" />
              <span className="keyword-name">{keyword.name}</span>
              <img src={iconSearch} alt="Search" className="keyword-icon keyword-search-icon" />
            </li>
          ))}
        </ul>
      ) : (
        <p>No keywords available</p>
      )}
    </div>
  );
};

export default SearchKeywords;
